var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#FBE7E3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E96347",
    d: "M33.963 32.291v-2.377a4.884 4.884 0 0 1 4.88-4.879h8.315a4.884 4.884 0 0 1 4.879 4.879v5.142h-2.708v-5.142a2.174 2.174 0 0 0-2.171-2.172h-8.316a2.174 2.174 0 0 0-2.171 2.172v5.118h-2.708v-2.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF9583",
    d: "M58.99 59.548H27.01c-1.11 0-2.01-.9-2.01-2.011V44.673a9.642 9.642 0 0 1 9.642-9.641h16.716A9.642 9.642 0 0 1 61 44.673v12.864c0 1.11-.9 2.01-2.01 2.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E96347",
    d: "M25 57.455c0 1.156.937 2.093 2.093 2.093h31.814A2.093 2.093 0 0 0 61 57.455v-2.664H25v2.664zM47.594 43.486h-2.472v-2.472a1.15 1.15 0 0 0-1.15-1.15h-1.945a1.15 1.15 0 0 0-1.149 1.15v2.472h-2.472a1.15 1.15 0 0 0-1.15 1.15v1.945c0 .635.515 1.15 1.15 1.15h2.472v2.472c0 .635.515 1.15 1.15 1.15h1.945a1.15 1.15 0 0 0 1.149-1.15V47.73h2.472a1.15 1.15 0 0 0 1.15-1.149v-1.945a1.15 1.15 0 0 0-1.15-1.15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboard);
export default __webpack_public_path__ + "static/media/ic-dashboard.f0ce35ef4cd422f66600892e6be2d6c0.svg";
export { ForwardRef as ReactComponent };